module.exports = __webpack_public_path__ + "static/media/federation-francaise-cardiologie.743a65bd.jpg";